angular.module('wbDashboard').controller('NotificationControllerAurea',
    ['$scope', '$timeout', 'Notification', 'Track', 'Display', 'PlanService',
function ($scope, $timeout, Notification, Track, Display, PlanService) {

    $scope.pageData = {};

    $scope.$watch(function() { return Notification.modal; }, function(notification) {
        if (notification) {
            $scope.notification = notification;

            switch (notification.link) {
                case "modal:overview":
                    Track.send("New Overview Modal", "overview");
                    break;
                case "modal:tax_plan":
                    Track.send("Tax Protection Announcement Modal", "Services");
                    break;
                case "modal:planning":
                    Track.send("Planning Announcement Modal", "planning");
                    break;
                case "modal:free_fast_money":
                    Track.send("Free Fast Money Modal", "planning");
                    break;
                case "modal:portfolio_plus":
                    Track.send("Portfolio Plus Modal", "planning");
                    break;
                case "modal:formulas":
                    Track.send("Formulas Announcement Modal", "planning");
                    break;
            }
        }
    });

    //hide menu
    Display.setMenu(false);

    $scope.dismissNotification = function(skipped) {
        // Notification.modal = false;
        // $scope.leaveNotification();
        // return;

        $scope.pageData.sending = true;
        Notification.read($scope.notification.id).then(function() {

            if (skipped && $scope.notification.link === "modal:planning") {
                Track.send("Planning Announcement Skipped", "planning");
            }
            if (!skipped && $scope.notification.link === "modal:planning") {
                Track.send("Planning Announcement Check Out", "planning");
            }

            //after it's marked read if there's another modal notification, it will be set
            //need to unset it to skip anymore modal notifications till next load
            Notification.modal = false;
            $scope.leaveNotification();

        }).finally(function() {
            $scope.pageData.sending = false;
        });

    };

    $scope.getNotificationTemplate = function() {
        var template, camelFile, path;

        template = 'app/themes/aurea/segments/notification/';
        camelFile = $scope.notification.link.replace(/[\b-_:][a-z]/g, function(letter) {
            return letter.replace(/[-_:]/g,"").toUpperCase();
        });
        path = template + camelFile + ".tpl.html";

        return path;

    };

    $scope.leaveNotification = function() {
        //doesn't refresh after agreement, so must refresh now
        angular.element("html, body").scrollTop(0);
        Display.setMenu(true);
        Display.setViewToMain();
        $timeout(function() {
            angular.element("html, body").animate({scrollTop: 0}, 200);
        });
    };

    var transitionDeregisterHook;
    transitionDeregisterHook = $scope.$transitions.onFinish({ to: 'base.**' }, function(trans) {
        if (Notification.modal) {
            Display.setMenu(false);
        }
    });
    $scope.$on('$destroy', function() {
        transitionDeregisterHook();
    });


}]);
